module.exports = __webpack_public_path__ + "static/media/arrows-horizontal.81bbef26.svg";